module.exports = __webpack_public_path__ + "static/mechanical-2ad1fdc0de61d409c397403d8f837094.png";